import { TechDataVariations, TechDataVehicle } from '@/types';
import { retry } from '@/utils/retry';

const getURL = async (stage: string) => {
  return stage === 'TEST' || stage === 'INT'
    ? 'https://dev.api.oneweb.mercedes-benz.com/vans-components-be/owv/v1'
    : 'https://api.oneweb.mercedes-benz.com/vans-components-be/owv/v1';
};

const useApi = {
  async get<T>(url: string, stage: string): Promise<T> {
    const response = await fetch(`${await getURL(stage)}/${url}`);
    if (!response.ok) {
      throw new Error(`Request failed with status code ${response.status}`);
    }
    return await response.json();
  },
};

export async function getData<T>(
  endpoint: string,
  market: string,
  language: string,
  stage: string,
  id: string,
): Promise<T | Error> {
  return await retry(
    () =>
      useApi.get<T>(
        `${endpoint}/${market.toUpperCase()}/${language.toLowerCase()}/${id}`,
        stage,
      ),
    2,
    500,
  );
}

export const loadVehicles = async (aemData: any) => {
  const response = await getData<TechDataVehicle[]>(
    'vehicles',
    aemData.country,
    aemData.language,
    aemData.stage,
    aemData.modelSeries,
  );

  return response;
};

export const loadVariations = async (aemData: any) => {
  const response = await getData<TechDataVariations>(
    'variations',
    aemData.country,
    aemData.language,
    aemData.stage,
    aemData.modelSeries,
  );

  return response;
};
